import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';

export default class FormSelect extends Component {
  render() {
    const { label, input, controlId, options, meta } = this.props;
    return (
      <FormGroup controlId={controlId || ''} style={{ marginBottom: '10px' }}>
        <ControlLabel>{label}</ControlLabel>
        <FormControl
          componentClass="select"
          onChange={input.onChange}
          {...input}
        >
          {options && options.length && options.map(
            (option, index) => {
              return <option value={option[0]} key={index}>{option[1]}</option>;
            },
          )}
        </FormControl>
        {meta.error && <HelpBlock>{meta.error}</HelpBlock>}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

FormSelect.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  input: PropTypes.object,
  options: PropTypes.array,
  meta: PropTypes.any,
};



// WEBPACK FOOTER //
// ./src/cms/form/FormSelect.js